import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/069-jpg file.svg")